<template>
  <div>
    <!-- <el-button type="text" @click="createGroupVisible = true">创建群聊</el-button> -->
    <div @click="createGroupVisible = true">创建团队</div>
    <el-dialog
      title="创建群聊"
      :visible.sync="createGroupVisible"
      width="70%"
      :before-close="handleClose"
    >
      <el-row>
        <el-col :span="12">
          <!-- 好友列表 -->
          <div v-loading="loading">
            <div v-for="friend in friendList" @click="onClickRow(friend)">
              <el-row>
                <el-col :span="2">
                  <i
                    v-if="friend['checked']"
                    style="color: rgb(38, 131, 190); font-size: 20px"
                    class="el-icon-success"
                  ></i>
                  <i
                    v-else
                    style="color: gray; font-size: 20px"
                    class="el-icon-success"
                  ></i>
                </el-col>
                <el-col :span="4">
                  <el-avatar
                    shape="square"
                    size="medium"
                    :src="
                      friend.imageUrl
                        ? friend.imageUrl
                        : 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png'
                    "
                  ></el-avatar>
                </el-col>
                <el-col :span="14">
                  {{ friend.userName }}
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <!-- 已选择好友头像列表 -->
          <div>
            <div style="margin-bottom: 10px">
              <span style="font-weight: bold; font-size: 18px">选择联系人</span>
              <span style="font-size: 12px; color: gray; float: right"
                >已选择 {{ selectedFriendList.length }} 个联系人</span
              >
            </div>
            <div
              v-for="friend in selectedFriendList"
              style="
                width: 55px;
                height: 55px;
                text-align: center;
                display: inline-block;
              "
            >
              <div>
                <el-avatar
                  shape="square"
                  size="medium"
                  :src="
                    friend.imageUrl
                      ? friend.imageUrl
                      : 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png'
                  "
                ></el-avatar>
                <i
                  class="el-icon-circle-close"
                  @click="onClickRow(friend)"
                  style="
                    position: absolute;
                    transform: translateY(-50%) translateX(-50%);
                    color: red;
                    font-size: 14px;
                    font-weight: bolder;
                    border-radius: 7px;
                  "
                ></i>
              </div>
              <div class="ellipsis">{{ friend.userName }}</div>
            </div>
          </div>
          <!-- 群名简介信息 -->
          <div style="margin: 10px 0">
            <el-input
              v-model="groupInfo.name"
              placeholder="请输入团队名称"
            ></el-input>
            <el-input
              style="margin: 10px 0"
              type="textarea"
              :rows="2"
              placeholder="请输入团队简介"
              v-model="groupInfo.describe"
            >
            </el-input>
          </div>
        </el-col>
      </el-row>
      <!-- 创建按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="createGroupVisible = false">取 消</el-button>
        <el-button type="primary" @click="createGroup">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { GetFriendList } from "@/api/friend";
import { createChatGroup } from "@/api/chat";
import { mapState, mapMutations } from "vuex";
export default {
  // 创建群聊
  name: "CreateGroupDialog",
  data() {
    return {
      loading: false,
      // 创建群聊的对话框
      createGroupVisible: false,
      // 选中的好友列表
      selectedFriendList: [],
      // 群聊名称等信息
      groupInfo: {},
      // 现存好友列表
      friendList: [],

      checkedFriendIds: [],
    };
  },
  components: {},
  computed: {
    ...mapState({
      my: (state) => state.user,
    }),
  },
  created() {
    this.getFriList();
  },
  async mounted() {},
  mounted() {},
  methods: {
    onClickRow(row) {
      console.log("onClickRow", row, this.selectedFriendList);

      if (row.checked) {
        row.checked = false;
        // 移出
        this.selectedFriendList = this.selectedFriendList.filter((item) => {
          return item.userId !== row.userId;
        });
      } else {
        row.checked = true;
        this.selectedFriendList.push(row);
      }
    },
    onCheckboxChange(val1, value2) {
      console.log("onCheckboxChange", val1, value2);
    },
    async getFriList() {
      console.log("async getFriList()");
      this.loading = true;
      const res = await GetFriendList();
      console.log("async mounted", res);
      if (res.code == 200) {
        this.friendList = res.data;
      }
      this.loading = false;
    },

    createGroup() {
      // 组织信息
      let ids = [];
      this.selectedFriendList.forEach((item) => {
        ids.push(item.userId);
      });
      if (this.groupInfo.name == null || this.groupInfo.name == "") {
        this.$message.warning("请输入团队名称");
        return;
      }
      if (ids == null || ids.length < 2) {
        this.$message.warning("请选择至少两个人");
        return;
      }
      let data = {
        ...this.groupInfo,
        ids: ids.join(","),
        userId: this.my.id,
      };
      console.log("createGroup", data);
      // 请求后台

      createChatGroup(data)
        .then((response) => {
          console.log("添加请求已经发送", response);
          if (response.code == 200) {
            let { groupId, groupName, describe } = response.data;

            // 添加并打开一个临时聊天窗口
            this.$message.success("创建成功");
            // let nFriendInfo = {
            //   friendId: groupId,
            //   friendName: groupName,
            //   msg: '',
            //   unreadMessages: 0,
            //   friendAvatar: null,
            //   type: 1, // 0单聊，1群聊
            // }
            // this.$store.state.msgContent.tempFriendInfo = nFriendInfo
          } else {
            console.error("response error:", response);
          }
        })
        .catch((error) => {
          console.error("Error adding group:", error);
        });
      // 关闭弹窗
      this.createGroupVisible = false;
    },
    handleClose(done) {
      done();
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => {});
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
  },
};
</script>

<style>
.ellipsis {
  overflow: hidden; /* 确保内容超出容器部分被隐藏 */
  white-space: nowrap; /* 防止文本换行 */
  text-overflow: ellipsis; /* 使用省略号表示文本溢出 */
  display: block; /* 或使用 inline-block，根据需要决定 */
  width: 100%; /* 根据父容器调整宽度 */
}
</style>
